'use client';
import cx from 'classnames';
import React, { useCallback, useEffect } from 'react';
import styles from './Dropdown.module.scss';
import { Button, Size, Theme } from '../Button';
export var THEME;
(function (THEME) {
    THEME["DARK"] = "dark";
    THEME["LIGHT"] = "light";
})(THEME || (THEME = {}));
export const Dropdown = ({ open = false, setOpen = () => { }, alert = '', children, className = '', doneClassName = '', disabled = false, done = true, doneLabel, error = false, label = '', hideMobileLabel = false, headerTitle, selection = '', onSubmit = () => { }, overlayPanelVariant, closeButtonText = 'Close', closeButtonIcon = 'close', disabledButton = false, analytics, analyticsNameSpace, analyticsFieldName, desktopLayout = 'default', theme = THEME.DARK, longContent = false, secondaryButtonAction, secondaryButtonLabel, }) => {
    const handleAnalytics = useCallback(() => {
        if (analyticsNameSpace && analyticsFieldName && analytics) {
            analytics({
                event: 'visitor interaction',
                interactionName: 'button click',
                linkText: `${analyticsNameSpace} | ${analyticsFieldName}`,
                linkUrl: '(no url destination)',
            });
        }
    }, [analyticsNameSpace, analyticsFieldName, analytics]);
    const handleSubmit = () => {
        setOpen(!open);
        onSubmit();
    };
    useEffect(() => {
        const launcher = document.getElementById('launcher');
        const maxWidth = 800;
        if (launcher && window.innerWidth < maxWidth) {
            launcher.style.display = open ? 'none' : 'block';
        }
        if (open) {
            handleAnalytics();
        }
        !open && document.body.classList.remove('bl-haven-dropdownOpen');
        open && document.body.classList.add('bl-haven-dropdownOpen');
    }, [open, handleAnalytics]);
    const containerStyles = cx(styles.dropdown, {
        [styles['-open']]: open,
        [styles['-error']]: error,
        [styles['-alert']]: alert,
        [styles['-disabled']]: disabled,
        [styles['-selected']]: selection,
        [styles['-longContent']]: longContent,
    }, styles[`-${desktopLayout}`], className);
    const themeStyle = cx({
        [styles['theme_dark']]: theme === THEME.DARK,
        [styles['theme_light']]: theme === THEME.LIGHT,
    });
    return (<div className={containerStyles}>
      <button className={cx(styles.dropdown__button, {
            [styles.overlayPanelVariant]: overlayPanelVariant,
        }, themeStyle)} onClick={() => setOpen(!open)} type='button'>
        {label && <span className={cx(styles.dropdown__label, themeStyle)}>{label}</span>}
        {selection && <span className={styles.dropdown__selection}>{selection}</span>}
      </button>

      {open && (<>
          <div className={styles.dropdown__decoration}/>

          <div className={styles.dropdown__menu}>
            <div className={styles.dropdown__content}>
              <div className={styles.dropdown__contentHeader}>
                {headerTitle ? (<span className={styles.dropdown__headerTitle}>{headerTitle}</span>) : null}
                <button className={`${styles.dropdown__closeButton} ${styles['-' + closeButtonIcon]}`} onClick={() => setOpen(false)} type='button'>
                  {closeButtonText}
                  <span className={styles.dropdown__closeButtonDecoration}/>
                </button>
              </div>
              {alert && <div className={styles.dropdown__alert}>{alert}</div>}
              <div className={styles.dropdown__contentInner}>
                {!hideMobileLabel ? <div className={styles.dropdown__title}>{label}</div> : null}
                {children}
              </div>
              {done && !overlayPanelVariant && (<button className={cx(styles.dropdown__doneButton, doneClassName)} onClick={handleSubmit} type='button'>
                  {doneLabel || 'Done'}
                </button>)}
              {done && overlayPanelVariant && (<div className={cx(styles.dropdown__footer, {
                    [styles.secondaryButtonDesktopContainer]: secondaryButtonLabel,
                })}>
                  {secondaryButtonLabel && (<Button theme={Theme.TERTIARY_THEME} scale={Size.SMALL_SIZE} disabled={!secondaryButtonAction} onClick={secondaryButtonAction}>
                      {secondaryButtonLabel}
                    </Button>)}
                  <Button theme={secondaryButtonLabel ? Theme.PRIMARY_THEME : Theme.TERTIARY_THEME} scale={Size.MEDIUM_SIZE} className={cx({
                    [styles.overlayPanelVariantDoneButton]: !secondaryButtonLabel,
                })} onClick={handleSubmit} disabled={disabledButton}>
                    {doneLabel || 'Done'}
                  </Button>
                </div>)}
            </div>
          </div>
        </>)}
      <button className={styles.dropdown__bgButton} onClick={() => setOpen(false)} type='button'>
        <span>close</span>
      </button>
    </div>);
};
